module.exports = __webpack_public_path__ + "img/bus_biei.86262598.jpg";